import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../api/api';
import * as types from './location_types';

import { hideLoader } from '../../redux_files/actions/loaderActions';

function reverseGeocodeAPI(lat, lng) {
  return api.post('location', { lat, lng }, {
    headers: { 'Content-Type': 'application/json; charset=UTF-8' },
  });
}

function* handleReverseGeocode(action) {
  try {
    const { lat, lng } = action.payload;
    const response = yield call(reverseGeocodeAPI, lat, lng);
    const address = response.data?.address || `Lat: ${lat.toFixed(4)}, Lng: ${lng.toFixed(4)}`;
    
    yield put({ 
      type: types.GET_ADDRESS_FROM_LOC, 
      payload: {
        success: true,
        address,
        location: { lat, lng }
      }
    });
    
    // Hide loader after reverse geocoding completes
    yield put(hideLoader());
  } catch (error) {
    const { lat, lng } = action.payload;
    const fallbackAddress = `Lat: ${lat?.toFixed(4)}, Lng: ${lng?.toFixed(4)}`;
    // Treat fallback as a successful resolution to avoid noisy errors
    yield put({ 
      type: types.GET_ADDRESS_FROM_LOC, 
      payload: {
        success: true,
        address: fallbackAddress,
        location: { lat, lng }
      }
    });
    
    // Hide loader even on error
    yield put(hideLoader());
  }
}

export function* locationSaga() {
  yield takeLatest(types.GET_ADDRESS_FROM_LOC, handleReverseGeocode);
}

export default locationSaga;
